<script lang="ts">
	//Formatters
	import { format } from 'svelte-i18n';
	//Helpers
	import { capFirstChar } from 'src/helpers/utilities';
	import { getFirmwareProgressMessage } from 'src/helpers/firmware_progress_helpers';
	//Design system components
	import { Alert, ProgressBar, Text } from '@Shelly/shelly-design-system';
	//Types

	export let updatingFW;
</script>

{#if updatingFW}
	{@const updateProgress = Math.min(updatingFW?.prog ?? 0, 100)}
	<Alert
		type="info"
		class="mb-s"
		customIcon="fas fa-arrows-rotate text-primary"
		isHeadingBold
		heading={capFirstChar(
			$format('device_status_updating', {
				default: 'updating',
			}),
		)}
	/>
	<Text class="mb-xs text-bold ml-s">
		{capFirstChar(getFirmwareProgressMessage(updateProgress) || '')}
	</Text>
	<ProgressBar
		class="width-full mb-xs"
		type={updateProgress >= 100 ? 'success' : 'primary'}
		progress={updateProgress}
	/>
	<Text class="text-color-muted mb-s ml-s" styleType="body-small">
		{$format('progress_state_percent_complete', {
			default: `${updateProgress}% Complete`,
			values: { progress: updateProgress },
		})}
	</Text>
{/if}
